import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Outlet} from "react-router-dom";
import {
    Box,
    Dialog,
    IconButton,
    Slide,
    Theme,
    Toolbar,
    Typography,
    LinearProgress
} from "@mui/material";
import {useTheme} from '@mui/material/styles';
import {useParams} from "react-router-dom";
import {ContainerClasses} from '../../themes/containerClasses'
import {CloseRounded} from "@mui/icons-material";
import {HeaderComponent} from "../../components/header/Header"
import {FooterComponent} from "../../components/footer/Footer"
import {CelebrationHost} from "../../screens/celebrations/CelebrationHost";
import {NavigationHorizontalComponent} from "../../components/navigationHorizontal/NavigationHorizontal"
import {retrieveApplication,
        selectApplication,
        selectAvailableApplications,
        selectTabs,
        selectApplicationPages,
        selectError,
        selectIsFetching as selectIsFetchingApplication} from "./appSlice";
import {Link} from "react-router-dom";
import {
  BaseModel,
  CustomPageModel
} from '../../models/models';
import {ErrorComponent} from "../../components/error/Error";
import {getAppName} from "../../utils/helperRouter";
import {useAuth} from "../../hooks/useAuth";

export const AppScreen = () => {

  const theme = useTheme();
  const styles = ContainerClasses();

  const { accessToken, onInvalidToken } = useAuth();

  const dispatch = useDispatch<any>();

//  const authToken = useSelector(selectAuthenticationToken);
  const fetchError = useSelector(selectError);
  const application = useSelector(selectApplication);
  const availableApplications = useSelector(selectAvailableApplications);
  const tabs = useSelector(selectTabs);
  const applicationPages = useSelector(selectApplicationPages);

  const isFetchingApplication = useSelector(selectIsFetchingApplication);

  const customPages = [new CustomPageModel('SearchPage_Id_sys', 'SearchPage_Uuid_sys', 'search', 'Search')]

  const {appName, objectName} = useParams();

  useEffect(() => {
    //reload app always when app changes
      const thisAppName = getAppName(appName);
      dispatch(retrieveApplication(thisAppName, accessToken, onInvalidToken));

  }, [appName]); // eslint-disable-line react-hooks/exhaustive-deps

  const isLoading = isFetchingApplication;

  return (
     <Box sx={styles.containerCol}>
       <CelebrationHost />
       <HeaderComponent />
       {application &&
         <NavigationHorizontalComponent
            application = {application}
            availableApplications = {availableApplications}
            tabs = {tabs}
            customPages = {customPages}
            applicationPages = {applicationPages}
         />
       }

       {isLoading && <LinearProgress color="primary" />}
       {!isLoading && <LinearProgress color="primary" variant="determinate" value={0}/>}


       {fetchError !== null &&
           <ErrorComponent
              errorMessage = {fetchError}
           />
       }

       {fetchError === null &&
             <Outlet />
        }

       <FooterComponent />

     </Box>

);
};
